/**
 * External dependencies
 */
import { omitBy, values } from 'lodash';

/**
 * Internal dependencies
 */
import { getEditedLayout } from 'state/dashboard-layouts/selectors';
import editLayout from './edit-layout';

export default (layoutId, itemId) => (dispatch, getState) => {
	const layout = getEditedLayout(getState(), layoutId);

	if (!layout) {
		return;
	}

	const updated = {
		items: values(omitBy(layout.items, { id: itemId })),
	};

	dispatch(editLayout(layoutId, updated));
};
